var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.$getImg(_vm.coverImagesUrl)

  var m1 = require("static/strategy/committed.png")

  var m2 = require("static/strategy/icon-star.png")

  var m3 = require("static/strategy/add-round.png")

  var m4 = require("static/strategy/icon-star.png")

  var m5 = require("static/strategy/add-round.png")

  var m6 = require("static/strategy/add-round.png")

  var m9 = require("static/strategy/add-round.png")

  var m10 = require("static/strategy/add.png")

  var l1 = _vm.__map(_vm.list, function(t, i) {
    var m8 = require("static/strategy/delect.png")

    var l0 = _vm.__map(t.showImgs, function(tt, ii) {
      var m7 = _vm.$getImg(tt)
      return {
        $orig: _vm.__get_orig(tt),
        m7: m7
      }
    })

    return {
      $orig: _vm.__get_orig(t),
      m8: m8,
      l0: l0
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.choiceScenic.show = true
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        m5: m5,
        m6: m6,
        m9: m9,
        m10: m10,
        l1: l1
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }